import React, { useState } from 'react';
import { DollarSign } from 'lucide-react';
import apiClient from '../../services/api/apiClient.js';
import { TraspasoForm, postTraspaso } from './BancosTraspasosPage.jsx';

/**
 * Botón "Traspaso" por fila de Bancos (V1 `ListadoBancos.jsx`: botón verde con icono "$"
 * que abre el modal "Traspaso de Banco {banco}" con el origen ya fijado a esa fila).
 */
export default function TraspasoBancoButton({ row, hasPermiso, recargar }) {
  const [abierto, setAbierto] = useState(false);
  const [bancos, setBancos] = useState([]);

  if (!hasPermiso('bancos-traspasos:crear')) return null;

  function abrir() {
    apiClient.get('/bancos', { params: { limit: 500 } })
      .then(({ data }) => setBancos(data.data || []))
      .catch(() => setBancos([]));
    setAbierto(true);
  }

  return (
    <>
      <button
        title="Traspaso" aria-label="Traspaso"
        className="p-1.5 rounded-md text-success-600 hover:bg-success-50"
        onClick={abrir}
      >
        <DollarSign size={15} />
      </button>
      {abierto && (
        <TraspasoForm
          open onClose={() => setAbierto(false)} bancos={bancos} bancoOrigenFijo={row}
          onSubmit={async (v) => { await postTraspaso(v); await recargar(); }}
        />
      )}
    </>
  );
}
